import SendsPagesOverview from "../Pages/Sends/Admin/SendsPagesOverview";
import UserSendsPage from "../Pages/Sends/User/UserSendsPage";
import CreateSendsPage from "../Pages/Sends/Admin/CreateSendsPage";
import EditSendsPage from "../Pages/Sends/Admin/EditSendsPage";
import SendsUsers from "../Pages/Sends/Admin/SendsUsers";
import ProtectedRoute from "../Framework/Routes/ProtectedRoute";
import AddressImporter from "../Components/AddressImporter/AddressImporter";
import SendsHistory from "../Pages/Sends/Admin/SendsHistory";
import UserSendsHistory from "../Pages/Sends/User/UserSendsHistory";

const AuthorisedRoutes : Array<any> = [
    {
        title: 'Profiles',
        path: '/sends-page',
        element:
            <ProtectedRoute>
                <UserSendsPage />
            </ProtectedRoute>
    },
    {
        title: 'Sends Profile',
        path: '/sends-page/:pageId',
        element:
            <ProtectedRoute>
                <UserSendsPage />
            </ProtectedRoute>
    },
    {
        title: 'Sends History',
        path: '/sends-page/history',
        element:
            <ProtectedRoute>
                <UserSendsHistory />
            </ProtectedRoute>
    },
    {
        index: true,
        title: 'Sends Admin',
        element:
            <ProtectedRoute blockSingleRoles={['SENDS_PAGE_USER']}>
                <SendsPagesOverview />
            </ProtectedRoute>
    },
    {
        title: 'Sends Admin',
        path: '/sends-admin/history',
        element:
            <ProtectedRoute blockSingleRoles={['SENDS_PAGE_USER']}>
                <SendsHistory />
            </ProtectedRoute>
    },
    {
        title: 'Sends Admin',
        path: '/sends-admin/users',
        element:
            <ProtectedRoute blockSingleRoles={['SENDS_PAGE_USER']}>
                <SendsUsers />
            </ProtectedRoute>
    },
    {
        title: 'Create Sends Profile',
        path: '/sends-admin/create',
        element:
            <ProtectedRoute blockSingleRoles={['SENDS_PAGE_USER']}>
                <CreateSendsPage />
            </ProtectedRoute>
    },
    {
        title: 'Edit Sends Profile',
        path: '/sends-admin/edit/:pageId',
        element:
            <ProtectedRoute blockSingleRoles={['SENDS_PAGE_USER']}>
                <EditSendsPage />
            </ProtectedRoute>
    },
    {
        title: 'Address Importer',
        path: '/address-importer',
        element:
            <ProtectedRoute blockSingleRoles={['SENDS_PAGE_USER']}>
                <AddressImporter />
            </ProtectedRoute>
    }
];

export default AuthorisedRoutes;
